import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=ecc4de72&scoped=true&"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc4de72",
  null
  
)

export default component.exports